import { withProps } from 'recompose'
import Logo from 'components/Logo/Logo'

const SurveyLexLogo = withProps({
  source: 'https://www.neurolex.ai/img/surveylex-logo.svg',
  companyName: 'SurveyLex'
})(Logo)

export default SurveyLexLogo
